<template>
  <div class="trans-slides" v-on:click="goSlideLink">
    <div class="bgimage"><img :src="blurry" /></div>
    <div class="bg2"><src-set-image :src="fsrc" /></div>
    <div class="steady-image" :class="{'trans-show': trans2Show}"><src-set-image :src="trans2Src" /></div>
    <div class="trans-image" :class="{'trans-show': trans1Show, trans: doTrans}"><src-set-image :src="trans1Src" /></div>
  </div>
</template>

<script>
import { setTimeout } from 'timers';
import SrcSetImage from '@/components/widgets/images/SrcSetImage.vue'
// slides is an array of url which we will transition between
export default {
  components: {
      SrcSetImage
  },
  props: {
    
    slides: {
      type: Array,
      default: function () { return [] }
    },
    delay: {
      type: Number,
      default: 2000
    }
  },
  data: function () {
    return {
      current: 0,
      trans1Src: null,
      trans2Src: null,
      trans1Show: false,
      trans2Show: false,
      doTrans: false,
      fsrc: null,
      blurry:'',
      curLink: ''
    }
  },
  created () {
    this.blurry = this.$k.randomBlurry()
    if(this.slides.length > 0) {
      this.setUp()
    }
  },
  mounted: function () {
    if(this.slides.length > 0) {
      this.startChanging
    }
  },
  beforeDestroy () {
    this.running = false
  },
  methods: {
    goSlideLink () {
      if(this.curLink) {
        this.$ixr.push(this.curLink)
      }
      
    },
    setUp () {
      if(this.slides.length > 0) {
        this.fsrc = this.slides[0].url
        this.curLink = this.slides[0].link
      }
    },
    startChanging: async function () {
      if(!this.running) {
        this.running = true
        await this.$k.waitfor(this.delay)
        if(this.running){
          this.changeImage()
        }
        
      }
    },
    stopChanging: async function () {
      this.running = false
      this.trans1Show = false
      this.trans2Show = false
    },
    changeImage: async function () {
      if(!this.running) {
        this.stopChanging()
        return
      }
      const max = this.slides.length
      if(max == 0) {
        this.callAgain()
        return;
      }
      if(this.current >= max) {
        this.current = 0
      }
      let url = this.slides[this.current].url
      this.trans1Src = url
      await this.$k.loadImage(url)
      if(!this.running) {
        this.stopChanging()
        return
      }
      this.doTrans = true
      this.trans1Show = true
      this.current++
      await this.$k.waitfor(400)
      if(!this.running) {
        this.stopChanging()
        return
      }
      this.curLink = this.slides[this.current].link
      this.trans2Src = url
      this.trans2Show = true
      this.doTrans = false
      await this.$k.waitfor(200)
      
      if(!this.running) {
        this.stopChanging()
        return
      }
      this.trans1Show = false
      await this.$k.waitfor(this.delay)  
      if(!this.running) {
        this.stopChanging()
        return
      }
      this.changeImage()

    },
    callAgain: function () {
      setTimeout(() => {
        if(!this.running) return
        this.changeImage()
      }, this.delay)
    }
  },
  watch: {
    slides() {
      if(this.slides) {
        if(this.slides.length > 0) {
          this.setUp()
          this.startChanging()
        }
      }
    }
  }
}
</script>

<style scoped>
.trans-image{
  opacity:0;
  pointer-events: none;
  position:absolute;
  top:0;
  left:0;
  z-index:5;
  width:100%;
  height:100%;
}

.trans-image.trans{
  transition:opacity 0.6s ease;
}

.bgimage{
  width:100%;
  z-index:1;
  min-height:56%;
}

.bg2{
  position:absolute;
  top:0;
  left:0;
  width:100%;
  z-index:2;
}

.bgimage img, .bg2 img{
  width:100%;
}

.steady-image{
  opacity:0;
  pointer-events: none;
  position:absolute;
  top:0;
  left:0;
  z-index:4;
  width:100%;
  height:100%;
}

.trans-image img, .steady-image img{
  display:block;
  width:100%;
  box-sizing: border-box;
}

.trans-image.trans-show, .steady-image.trans-show{
  opacity:1;
}

.trans-slides{
  position:relative;
  z-index:30;
  width:100%;
  top:0;
  left:0;
  box-sizing: border-box;
  cursor:pointer;
}
</style>
